export default __webpack_public_path__ + "static/media/g.fdc2073e1b5e6ea964716c76d8153ba0.mp3";